import React from 'react';
import { Fabric, loadTheme, initializeIcons } from '@fluentui/react';
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
} from 'react-router-dom';
import AuthRoute from './access-routes/AuthRoute';
import GuestRoute from './access-routes/GuestRoute';
import MasterLayout from './layouts/Master';
import AuthenticateLayout from './layouts/Authenticate';
import { defaultRoute } from './routes/default-route-redirect';
import ThemeSwitcher from './components/ThemeSwitcher';
import DynamicPage from './pages/DynamicPage';

loadTheme({
  fonts: {
    medium: {
      fontFamily: '"IBM Plex Sans", sans-serif',
    },
  },
  palette: {
    themePrimary: 'var(--pl-color-themePrimary)',
    themeLighterAlt: 'var(--pl-color-themeLighterAlt)',
    themeLighter: 'var(--pl-color-themeLighter)',
    themeLight: 'var(--pl-color-themeLight)',
    themeTertiary: 'var(--pl-color-themeTertiary)',
    themeSecondary: 'var(--pl-color-themeSecondary)',
    themeDarkAlt: 'var(--pl-color-themeDarkAlt)',
    themeDark: 'var(--pl-color-themeDark)',
    themeDarker: 'var(--pl-color-themeDarker)',
    neutralLighterAlt: 'var(--pl-color-neutralLighterAlt)',
    neutralLighter: 'var(--pl-color-neutralLighter)',
    neutralLight: 'var(--pl-color-neutralLight)',
    neutralQuaternaryAlt: 'var(--pl-color-neutralQuaternaryAlt)',
    neutralQuaternary: 'var(--pl-color-neutralQuaternary)',
    neutralTertiaryAlt: 'var(--pl-color-neutralTertiaryAlt)',
    neutralTertiary: 'var(--pl-color-neutralTertiary)',
    neutralSecondary: 'var(--pl-color-neutralSecondary)',
    neutralPrimaryAlt: 'var(--pl-color-neutralPrimaryAlt)',
    neutralPrimary: 'var(--pl-color-neutralPrimary)',
    neutralDark: 'var(--pl-color-neutralDark)',
    black: 'var(--pl-color-black)',
    white: 'var(--pl-color-white)',
  },
});

initializeIcons();

class App extends React.Component {
  render() {
    return (
      <Fabric>
        <ThemeSwitcher />
        <Router basename={`${process.env.PUBLIC_URL}`}>
          <Switch>
            <Redirect exact from="/" to={`/${defaultRoute}`} />
            <GuestRoute
              path="/auth"
              component={(props) => <AuthenticateLayout {...props} />}
            />
            <AuthRoute
              path="/"
              component={(props) => <MasterLayout {...props} />}
            />
            <Route component={DynamicPage} />
          </Switch>
        </Router>
      </Fabric>
    );
  }
}

export default App;
